<app-back-header [headerText]="'Torna ai preventivi'" (backAction)="onCancel()" class="sticky-top">
</app-back-header>

<h3>Dettaglio preventivo:</h3>
<p class="small text-muted">I campi inseriti non sono modificabili.</p>

<p>Preventivo per {{ displayDocumentType }}</p>
<!-- <p>Clicca su una scheda per espanderne il contenuto</p> -->

<!-- <div class="d-flex align-items-center gap-3 mb-3">
  <mat-chip
    [color]="invoiceForm.get('is_paid')?.value ? 'primary' : 'warn'"
    selected
    class="aligned-chip"
  >
    <mat-icon matChipAvatar>{{
      invoiceForm.get("is_paid")?.value ? "check_circle" : "cancel"
    }}</mat-icon>
    {{ invoiceForm.get("is_paid")?.value ? "PAGATA" : "NON PAGATA" }}
  </mat-chip>

  <mat-chip
    [color]="invoiceForm.get('status')?.value ? 'primary' : 'warn'"
    selected
  >
    {{ invoiceForm.get("status")?.value }}
  </mat-chip>
</div> -->

<p><strong>Valido fino a:</strong> {{ invoiceForm.get('validity_date')?.value ? formatFormDate('validity_date') : '-' }} </p>


<div class="col-md-12 d-flex flex-column mb-3">
  <mat-expansion-panel
    class="h-100 mt-md-0 mt-3 custom-card"
    #panelclient>
    <!-- <mat-card-content class="h-100"> -->
      <mat-expansion-panel-header>
        <mat-panel-title>
          Cliente
        </mat-panel-title>
        <mat-panel-description>
          {{ company_name ?company_name : 'Nessuno' }}
          <span class="panel-state">{{ panelclient.expanded ? 'Chiudi' : 'Apri' }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <!-- <h5 class="mb-3">Cliente selezionato</h5> -->

      <!-- Add your content for the second card here -->
      <div class="d-flex flex-column h-100 justify-content-center">
        <div class="row">
          
          <!-- Show when no company is selected -->
          <div *ngIf="!company_id" class="text-center text-muted py-4">
            <mat-icon class="mb-2">face</mat-icon>
            <p>Nessun cliente selezionato</p>
            <small>Seleziona un cliente dalla barra di ricerca</small>
          </div>

          <div class="row">
            <!-- Show when company is selected -->
            <div *ngIf="company_name" class="company-details w-sm-50">
              <div class="mb-3">
                <label class="form-label fw-bold text-secondary">Nome</label>
                <div class="p-2 bg-light rounded border">
                  {{ company_name }}
                </div>
              </div>
            </div>

            <div *ngIf="company_iva_number" class="company-details w-sm-50">
              <div class="mb-3">
                <label class="form-label fw-bold text-secondary">Partita IVA</label>
                <div class="p-2 bg-light rounded border">
                  {{ company_iva_number }}
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="row">
          
          <!-- Show when no company is selected -->
          <div *ngIf="!company_id" class="text-center text-muted py-4">
            <mat-icon class="mb-2">face</mat-icon>
            <p>Nessun cliente selezionato</p>
            <small>Seleziona un cliente dalla barra di ricerca</small>
          </div>

          <div class="row">
            <!-- Show when company is selected -->
            <div *ngIf="company_address" class="company-details w-sm-50">
              <div class="mb-3">
                <label class="form-label fw-bold text-secondary">Indirizzo</label>
                <div class="p-2 bg-light rounded border">
                  {{ company_address }}
                </div>
              </div>
            </div>

            <div *ngIf="company_addressee_code" class="company-details w-sm-50">
              <div class="mb-3">
                <label class="form-label fw-bold text-secondary">Codice SDI</label>
                <div class="p-2 bg-light rounded border">
                  {{ company_addressee_code }}
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>

  </mat-expansion-panel>    
</div>

<form [formGroup]="invoiceForm">
  <mat-expansion-panel 
    class="mb-3 col-md-12 d-flex flex-column custom-card"
    #panel
    >
    <!-- <mat-card-content> -->
      <mat-expansion-panel-header>
      <mat-panel-title>
        Documento
      </mat-panel-title>
      <mat-panel-description>
        Prev. {{ invoiceForm.get('progressive_number')?.value ? invoiceForm.get('progressive_number')?.value : 'n' }}/{{ invoiceForm.get('enumeration')?.value ? invoiceForm.get('enumeration')?.value : 'Anno' }}
        <span class="panel-state">{{ panel.expanded ? 'Chiudi' : 'Apri' }}</span>
      </mat-panel-description>
    </mat-expansion-panel-header>
      <!-- <h5 class="mb-3">Dati documento</h5> -->

      <div class="row">
        <!-- <mat-form-field appearance="outline" class="w-sm-50">
          <mat-label>Nome fattura</mat-label>
          <input matInput formControlName="invoice_name"  readonly />
        </mat-form-field> -->

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Numero progressivo</mat-label>
          <input
            matInput
            formControlName="progressive_number"
            
            readonly
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Numerazione</mat-label>
          <input matInput formControlName="enumeration"  readonly />
        </mat-form-field>

      <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Valuta</mat-label>
          <input matInput formControlName="currency"  readonly />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Lingua</mat-label>
          <input 
            matInput 
            [value]="getLanguageDisplayName()" 
             
            readonly 
          />
        </mat-form-field>
      </div>

      <div class="row">
        <!-- <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Valuta</mat-label>
          <mat-select formControlName="currency" [disabled]="true">
            <mat-option
              *ngFor="let type of currencyOptions"
              [value]="type.code"
            >
              {{ type.name }}
            </mat-option>
          </mat-select>
        </mat-form-field> -->

        <mat-form-field appearance="outline" class="w-sm-50">
          <mat-label>Descrizione/Oggetto preventivo</mat-label>
          <textarea
            matInput
            formControlName="description"
            
            readonly
          ></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-50">
          <mat-label>Note</mat-label>
          <textarea
            matInput
            formControlName="notes"
            
            readonly
          ></textarea>
        </mat-form-field>
      </div>
    <!-- </mat-card-content> -->
  </mat-expansion-panel>

  <mat-expansion-panel 
    class="mb-3 col-md-12 d-flex flex-column custom-card"
    #panel2
    >
    <!-- <mat-card-content> -->
      <mat-expansion-panel-header>
        <mat-panel-title>
          Dettagli
        </mat-panel-title>
        <mat-panel-description>
          Creato il {{ formatFormDate('emission_date') }}
          <span class="panel-state">{{ panel2.expanded ? 'Chiudi' : 'Apri' }}</span>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <!-- <h5 class="mb-3">Fatturazione elettronica</h5> -->

      <div class="row">
        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Data di emissione</mat-label>
          <input 
            matInput 
            formControlName="emission_date"  
            readonly
            [value]="formatFormDate('emission_date')"
          />
          <!-- <mat-datepicker-toggle
          matSuffix
          [for]="emissionDatePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #emissionDatePicker></mat-datepicker> -->
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Data di pagamento</mat-label>
          <input 
            matInput 
            formControlName="payment_date"  
            readonly 
            [value]="formatFormDate('payment_date')"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Marca da bollo</mat-label>
          <input matInput formControlName="revenue_stamp"  readonly />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Marca da bollo a carico del cliente</mat-label>
          <input 
            matInput 
            [value]="getBooleanDisplay(invoiceForm.get('revenue_stamp_for_company')?.value)" 
            readonly 
          />
        </mat-form-field>

        <!-- <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Metodo di pagamento</mat-label>
          <mat-select formControlName="payment_method" [disabled]="true">
            <mat-option
              *ngFor="let type of paymentMethodOptions"
              [value]="type.code"
            >
              {{ type.code }} - {{ type.name }}
            </mat-option>
          </mat-select>
        </mat-form-field> -->

        <!-- <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Esigibilità IVA</mat-label>
          <input matInput formControlName="iva_collectability" readonly />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25-mobile-25">
          <mat-label>Codice destinatario</mat-label>
          <input matInput formControlName="addressee_code"  readonly />
        </mat-form-field> -->

      </div>

        <!-- <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Nome destinatario</mat-label>
          <input matInput formControlName="addressee_name"  readonly />
        </mat-form-field> -->

        <!-- <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Tipo documento</mat-label>
          <input 
            matInput 
            [value]="displayDocumentType" 
            readonly 
            placeholder="Seleziona tipo documento" />
        </mat-form-field> -->

        <!-- <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Metodo di pagamento</mat-label>
          <input matInput formControlName="payment_method"  readonly />
        </mat-form-field> -->

        <!-- <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Metodo di pagamento</mat-label>
          <input 
            matInput 
            [value]="displayPaymentMethodType" 
            readonly 
            placeholder="Seleziona tipo documento" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-50">
          <mat-label>IBAN</mat-label>
          <input matInput formControlName="iban"  readonly />
        </mat-form-field> -->

      <div class="row">
        <!-- <div class="w-sm-25-mobile-25">
          <mat-label>Esigibilità IVA</mat-label>
          {{ invoiceForm.get('iva_collectability')?.value }}
        </div> -->

        <!-- <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Pubblica Amministrazione</mat-label>
          <mat-select formControlName="p_a">
            <mat-option [value]="true">Si</mat-option>
            <mat-option [value]="false">No</mat-option>
          </mat-select>
        </mat-form-field> -->

        <!-- <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Pubblica Amministrazione</mat-label>
          <input 
            matInput 
            [value]="getBooleanDisplay(invoiceForm.get('p_a')?.value)" 
            readonly 
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-sm-25">
          <mat-label>Fattura sanitaria</mat-label>
          <input 
            matInput 
            [value]="getBooleanDisplay(invoiceForm.get('healthcare_invoice')?.value)" 
            readonly 
          />
        </mat-form-field> -->

      </div>
    <!-- </mat-card-content> -->
  </mat-expansion-panel>

  <mat-expansion-panel 
    class="mb-3 col-md-12 d-flex flex-column custom-card"
    #panel3
    >
      <mat-expansion-panel-header>
          <mat-panel-title>
            Prestazioni
          </mat-panel-title>
          <mat-panel-description>
            Aggiunte: <span class="article-badge">{{ productServices.length }}</span>
            <span class="panel-state">{{ panel3.expanded ? 'Chiudi' : 'Apri' }}</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
      <!-- <h6>Prodotti e servizi:</h6> -->
      
      <div class="hidden-mobile">

       <!-- Products and services table -->
      <div *ngIf="isLoadingProducts" class="loading-container">
        <p>Caricamento prodotti/servizi...</p>
      </div>

      <div *ngIf="!isLoadingProducts && productServices.length === 0" class="no-data-container">
        <mat-icon>sentiment_neutral</mat-icon>
        <p>Nessun prodotto o servizio associato a questa fattura.</p>
      </div>

      <div *ngIf="!isLoadingProducts && productServices.length > 0" class="table-container">
        <table mat-table [dataSource]="productServices" class="mat-elevation-z1">
          
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Nome </th>
            <td mat-cell *matCellDef="let product"> {{product.name}} </td>
          </ng-container>

          <!-- Quantity Column -->
          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef> Quantità </th>
            <td mat-cell *matCellDef="let product"> {{product.quantity}} </td>
          </ng-container>

          <!-- Units Column -->
          <ng-container matColumnDef="units">
            <th mat-header-cell *matHeaderCellDef> Unità </th>
            <td mat-cell *matCellDef="let product"> {{product.units}} </td>
          </ng-container>

          <!-- Gross Amount Column -->
          <ng-container matColumnDef="gross_amount">
            <th mat-header-cell *matHeaderCellDef> Importo Lordo </th>
            <td mat-cell *matCellDef="let product"> {{product.gross_amount | currency:'EUR'}} </td>
          </ng-container>

          <!-- Discount Column -->
          <ng-container matColumnDef="discount">
            <th mat-header-cell *matHeaderCellDef> Sconto (%) </th>
            <td mat-cell *matCellDef="let product"> {{product.discount}}% </td>
          </ng-container>

          <!-- IVA Percentage Column -->
          <ng-container matColumnDef="iva_percentage">
            <th mat-header-cell *matHeaderCellDef> IVA (%) </th>
            <td mat-cell *matCellDef="let product"> {{product.iva_percentage}}% </td>
          </ng-container>

          <!-- IVA Amount Column -->
          <ng-container matColumnDef="iva_amount">
            <th mat-header-cell *matHeaderCellDef> Importo IVA </th>
            <td mat-cell *matCellDef="let product"> {{product.iva_amount | currency:'EUR'}} </td>
          </ng-container>

          <!-- Final Amount Column -->
          <ng-container matColumnDef="final_amount">
            <th mat-header-cell *matHeaderCellDef> Totale </th>
            <td mat-cell *matCellDef="let product"> {{product.final_amount | currency:'EUR'}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <!-- Summary of product services -->
        <mat-divider class="mt-2"></mat-divider>
        <div class="product-summary me-2 mt-1 mb-3">
          <div class="summary-item ms-2">
            <span class="label">Totale prodotti/servizi:</span>
            <span class="value">{{ getTotalProductServices() | currency:'EUR' }}</span>
          </div>
          <div class="summary-item ms-2">
            <span class="label">Numero voci:</span>
            <span class="value">{{ productServices.length }}</span>
          </div>
        </div>
      </div>

    </div>

    <!-- mobile cards -->
    <div class="visible-mobile">
      <!-- here -->
       <h6 class="mt-2">Prodotti e servizi:</h6>

      <!-- Mobile loading state -->
      <div *ngIf="isLoadingProducts" class="loading-container">
        <p>Caricamento prodotti/servizi...</p>
      </div>

      <!-- Mobile empty state -->
      <div *ngIf="!isLoadingProducts && productServices.length === 0" class="no-data-container">
        <mat-icon>sentiment_neutral</mat-icon>
        <p>Nessun prodotto o servizio associato a questa fattura.</p>
      </div>

      <!-- Mobile product cards -->
      <div *ngIf="!isLoadingProducts && productServices.length > 0" class="mobile-products-container">
        <mat-card *ngFor="let product of productServices" class="product-card mb-3">
          <mat-card-header class="pb-2">
            <mat-card-title class="product-name">{{ product.name }}</mat-card-title>
          </mat-card-header>
          
          <mat-card-content class="product-details">
            <div class="detail-row">
              <span class="label">Quantità:</span>
              <span class="value">{{ product.quantity }} {{ product.units }}</span>
            </div>
            
            <div class="detail-row">
              <span class="label">Importo lordo:</span>
              <span class="value">{{ product.gross_amount | currency:'EUR' }}</span>
            </div>
            
            <div class="detail-row" *ngIf="product.discount">
              <span class="label">Sconto:</span>
              <span class="value">{{ product.discount }}%</span>
            </div>
            
            <div class="detail-row">
              <span class="label">IVA:</span>
              <span class="value">{{ product.iva_percentage }}% ({{ product.iva_amount | currency:'EUR' }})</span>
            </div>
            
            <mat-divider class="my-2"></mat-divider>
            
            <div class="detail-row total">
              <span class="label">Totale:</span>
              <span class="value">{{ product.final_amount | currency:'EUR' }}</span>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- Mobile summary -->
        <div class="product-summary mt-3">
          <mat-divider></mat-divider>
          <div class="summary-item">
            <span class="label">Totale prodotti/servizi:</span>
            <span class="value">{{ getTotalProductServices() | currency:'EUR' }}</span>
          </div>
          <div class="summary-item">
            <span class="label">Numero voci:</span>
            <span class="value">{{ productServices.length }}</span>
          </div>
        </div>
      </div>
    </div>

  </mat-expansion-panel>

  <mat-card class="mb-3 col-md-12 d-flex flex-column custom-card">
    <mat-card-content>
      <h4 class="m-2">Riepilogo:</h4>

      <!-- <div class="summary-item">
        <span class="label">Numero articoli:</span>
         <span class="value">{{ productServices.length }}</span>
      </div> -->

      <mat-divider></mat-divider>
      <div class="summary-item">
        <span class="fw-medium">Competenze:</span>
        <span class="fw-medium">{{ invoiceForm.get('gross_amount')?.value | currency:'EUR' }}</span>
      </div>

      <div class="summary-item">
        <span class="label">Marca da bollo:</span>
        <span class="value"> {{ invoiceForm.get('revenue_stamp')?.value | currency:'EUR' }}</span>
      </div>

      <div class="summary-item" *ngIf="invoiceForm.get('discount_amount')?.value > 0">
        <span class="label" *ngIf="invoiceForm.get('discount_amount')?.value > 0">
          Sconto:
        </span>
        <span class="value" *ngIf="invoiceForm.get('discount_amount')?.value > 0">
          - {{ invoiceForm.get('discount_amount')?.value | currency:'EUR' }} 
        </span>
      </div>

      <mat-divider *ngIf="invoiceForm.get('revenge')?.value > 0"></mat-divider>
      <div class="summary-item" *ngIf="invoiceForm.get('revenge')?.value > 0">
        <span class="label" *ngIf="invoiceForm.get('revenge')?.value > 0">
          Rivalsa ({{invoiceForm.get('revenge_rate')?.value}}%):
        </span>
        <span class="value" *ngIf="invoiceForm.get('revenge')?.value > 0">
          + {{ invoiceForm.get('revenge')?.value | currency:'EUR' }} 
        </span>
      </div>

      <mat-divider class="summary-item" *ngIf="invoiceForm.get('pension_fund')?.value > 0"></mat-divider>
      <div class="summary-item" *ngIf="invoiceForm.get('pension_fund')?.value > 0">
        <span class="label" *ngIf="invoiceForm.get('pension_fund')?.value > 0">
          Cassa previdenziale ({{invoiceForm.get('pension_fund_rate')?.value}}%):
        </span>
        <span class="value" *ngIf="invoiceForm.get('pension_fund')?.value > 0">
          + {{ invoiceForm.get('pension_fund')?.value | currency:'EUR' }}
        </span>
      </div>
      <span class="ms-2 small text-muted" *ngIf="invoiceForm.get('pension_fund')?.value > 0">
         {{ getPensionFundDisplayName() }} 
      </span>

      <mat-divider></mat-divider>
      <div class="summary-item">
        <span class="fw-medium">Imponibile:</span>
        <span class="fw-medium">{{ invoiceForm.get('taxable_amount')?.value | currency:'EUR' }}</span>
      </div>

      <mat-divider></mat-divider>
      <div class="summary-item">
        <span class="label">Iva ({{invoiceForm.get('iva_percentage')?.value}}%):</span>
        <span class="value">+ {{ invoiceForm.get('iva_amount')?.value | currency:'EUR' }}</span>
      </div>

      <mat-divider *ngIf="invoiceForm.get('withholding_advance_tax')?.value > 0"></mat-divider>
      <div class="summary-item" *ngIf="invoiceForm.get('withholding_advance_tax')?.value > 0">
        <span class="label" *ngIf="invoiceForm.get('withholding_advance_tax')?.value > 0"
          >Ritenuta d'acconto ({{invoiceForm.get('withholding_advance_tax_rate')?.value}}%):
        </span>
        <span class="value" *ngIf="invoiceForm.get('withholding_advance_tax')?.value > 0">
          - {{ invoiceForm.get('withholding_advance_tax')?.value | currency:'EUR' }}
        </span>
      </div>

      <mat-divider *ngIf="invoiceForm.get('withholding_tax')?.value > 0"></mat-divider>
      <div class="summary-item" *ngIf="invoiceForm.get('withholding_tax')?.value > 0">
        <span class="label" *ngIf="invoiceForm.get('withholding_tax')?.value > 0">
          Ritenuta ({{invoiceForm.get('withholding_tax_rate')?.value}}%):
        </span>
        <span class="value" *ngIf="invoiceForm.get('withholding_tax')?.value > 0">
          - {{ invoiceForm.get('withholding_tax')?.value | currency:'EUR' }}
        </span>
      </div>

      <mat-divider></mat-divider>
      <div class="summary-item total">
        <span class="label">Totale da incassare:</span>
        <span class="value">{{ invoiceForm.get('amount')?.value | currency:'EUR' }}</span>
      </div>
    </mat-card-content>
  </mat-card>
</form>

<div class="pb-3 d-flex flex-column align-self-end">
  <div class="mb-3 d-flex align-self-end">
    <!-- <button
      mat-raised-button
      color="primary "
      class="me-3 hidden-mobile"
      (click)="duplicateInvoice()"
    >
      <mat-icon>copy_all</mat-icon>
      Duplica
    </button> -->
    <button
      mat-raised-button
      color="primary"
      class="me-3 hidden-mobile"
      (click)="downloadPdf(invoiceId)"
    >
      <mat-icon>print</mat-icon>
      Scarica PDF
    </button>
    <button
        mat-raised-button
        color="primary "
        class="me-3 hidden-mobile"
        (click)="downloadXml()"
        >
        <mat-icon>download</mat-icon>
        Download XML
    </button>
    <button
      mat-raised-button
      color="primary"
      class="me-3 hidden-mobile"
      (click)="sendInvoiceEmail()"
    >
      <mat-icon>outgoing_mail</mat-icon>
      Invia preventivo per email
    </button>

  </div>
  <div class="mb-3 d-flex align-self-center">
    <!-- <button
      mat-raised-button
      color="primary"
      class="me-3 visible-mobile"
      (click)="duplicateInvoice()"
    >
      <mat-icon>copy_all</mat-icon>
      Duplica
    </button> -->
    <button
      mat-raised-button
      color="primary"
      class="me-3 visible-mobile"
      (click)="downloadPdf(invoiceId)"
    >
      <mat-icon>print</mat-icon>
      PDF
    </button>
    <button
        mat-raised-button
        color="primary "
        class="me-3 visible-mobile"
        (click)="downloadXml()"
        >
        <mat-icon>download</mat-icon>
        XML
    </button>
  </div>
  <!-- Mail send button for mobile -->
  <div 
    *ngIf="invoiceForm.get('is_draft')?.value == false" 
    class="mb-3 d-flex align-self-center">

    <button
      mat-raised-button
      color="primary"
      class="me-3 visible-mobile"
      (click)="sendInvoiceEmail()"
    >
      <mat-icon>outgoing_mail</mat-icon>
      Invia preventivo per email
    </button>

  </div>

</div>
